export default function TaskForm({
  form,
  setForm,
  onSubmit,
  loading,
}) {


return (

<form
 onSubmit={onSubmit}
 className="
 bg-[#1a1d24]
 border
 border-slate-800
 rounded-2xl
 p-5
 mb-8
 space-y-4
 "
>


<input
 type="text"
 placeholder="Task title..."
 value={form.title}
 onChange={(e)=>
  setForm({
   ...form,
   title:e.target.value
  })
 }
 className="
 w-full
 bg-[#111318]
 border
 border-slate-700
 rounded-xl
 px-4
 py-3
 outline-none
 focus:border-blue-500
 "
/>


<textarea
 placeholder="Description..."
 rows={4}
 value={form.description}
 onChange={(e)=>
  setForm({
   ...form,
   description:e.target.value
  })
 }
 className="
 w-full
 bg-[#111318]
 border
 border-slate-700
 rounded-xl
 px-4
 py-3
 outline-none
 resize-none
 focus:border-blue-500
 "
/>


<div className="grid grid-cols-1 md:grid-cols-3 gap-4">


<select
 value={form.priority}
 onChange={(e)=>
  setForm({
   ...form,
   priority:e.target.value
  })
 }
 className="
 bg-[#111318]
 border
 border-slate-700
 rounded-xl
 px-4
 py-3
 "
>

<option value="low">
Low Priority
</option>

<option value="medium">
Medium Priority
</option>

<option value="high">
High Priority
</option>

</select>


<input
 placeholder="Assign to..."
 value={form.assigned_to}
 onChange={(e)=>
  setForm({
   ...form,
   assigned_to:e.target.value
  })
 }
 className="
 bg-[#111318]
 border
 border-slate-700
 rounded-xl
 px-4
 py-3
 "
/>


<button
 disabled={loading}
 className="
 bg-blue-600
 hover:bg-blue-500
 rounded-xl
 font-semibold
 py-3
 "
>

{
loading
?
"Creating..."
:
"Create Task"
}

</button>


</div>


</form>

)

}